import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfidentialScanningSwitchComponent } from '@client/app/components/confidential-scanning-switch/confidential-scanning-switch.component';
import { ScanningAgentDebugModeSwitchComponent } from '@client/app/components/scanning-agent-debug-mode-switch/scanning-agent-debug-mode-switch.component';
import { SharedModule } from '../../shared/shared.module';
import { TenantsComponent } from './tenants.component';
import { TenantDetailsComponent } from './tenant-details/tenant-details.component';
import { TenantWorkspacesTableComponent } from './tenant-details/tenant-workspaces-table/tenant-workspaces-table.component';
import { CreateTenantComponent } from './create-tenant/create-tenant.component';
import { EditTenantComponent } from './edit-tenant/edit-tenant.component';
import { TenantConfigureSsoComponent } from './configure-sso/tenant-configure-sso.component';
import { MigrateWorkspaceModalComponent } from './tenant-details/migrate-workspace-modal/migrate-workspace-modal.component';
import { TenantWorkspaceDetailsComponent } from './workspace-details/workspace-details.component';
import { TenantWorkspaceDigitalPropertiesListComponent } from './workspace-details/digital-properties-list/digital-properties-list.component';
import { MigrateWorkspaceConfirmationModalComponent } from './tenant-details/migrate-workspace-confirmation-modal/migrate-workspace-confirmation-modal.component';
import { MigrationTroubleshootModalComponent } from './tenant-details/migration-troubleshoot-modal/migration-troubleshoot-modal.component';
import { TenantRemoveSsoModalComponent } from './configure-sso/tenant-remove-sso-modal/tenant-remove-sso-modal.component';
import { TenantTabWorkspacesComponent } from './tenant-details/tenant-tab-workspaces/tenant-tab-workspaces.component';
import { TenantTabAcademyComponent } from './tenant-details/tenant-tab-academy/tenant-tab-academy.component';
import { TenantAcademyTableComponent } from './tenant-details/tenant-academy-table/tenant-academy-table.component';
import { AssignAcademyRolesModalComponent } from './tenant-details/assign-academy-roles/assign-academy-roles-modal.component';
import { EditTenantWorkspaceComponent } from './tenant-details/upsert-tenant-workspace/edit/edit-tenant-workspace.component';
import { CreateTenantConfirmationModalComponent } from './create-tenant/create-tenant-confirmation-modal/create-tenant-confirmation-modal.component';
import { UsageLimitComponent } from './upsert-tenant/usage-limit-component/usage-limit.component';
import { DigitalAssetComplexityCalculatorComponent } from './upsert-tenant/digital-asset-complexity-calculator/digital-asset-complexity-calculator.component';
import { TenantWorkspaceDigitalPropertiesEditComponent } from '../../components/tenant/workspace/edit-tenant-workspace-digital-property/edit-tenant-workspace-digital-property.component';
import { AmpApiKeyModalComponent } from './edit-tenant/amp-api-key-modal/amp-api-key-modal.component';
import { AmpApiKeyComponent } from './edit-tenant/amp-api-key/amp-api-key.component';
import { EditTenantWorkspaceDigitalPropertyFormComponent } from '../../components/tenant/workspace/edit-tenant-workspace-digital-property-form/edit-tenant-workspace-digital-property-form.component';
import { AllOrganizationsComponent } from './organizations/all/all-organizations.component';
import { OrganizationsTableComponent } from './organizations/organizations-table/organizations-table.component';
import { PortfolioSharedModule } from '../../pages/public/portfolio/portfolio-shared.module';
import { CreateDigitalPropertyComponent } from './workspace-details/create-digital-property/create-digital-property.component';
import { CreateBulkWsPlusDpComponent } from './tenant-details/upsert-tenant-workspace/create-bulk-ws-plus-dp/create-bulk-ws-plus-dp.component';
import { CreateTenantWorkspaceSelectorComponent } from './tenant-details/upsert-tenant-workspace/create-tenant-workspace-selector/create-tenant-workspace-selector.component';
import { CreateTenantWorkspacePlusDpComponent } from '../../components/tenant/workspace/create-tenant-workspace-plus-dp/create-tenant-workspace-plus-dp.component';
import { ScanningAgentSwitchComponent } from '../../components/scanning-agent-switch/scanning-agent-switch.component';
import { PackageSelectorComponent } from './upsert-tenant/package-selector/package-selector.component';
import { ScanDefaultTimeoutComponent } from './upsert-tenant/scan-default-timeout/scan-default-timeout.component';

const sharedComponents: any[] = [
  TenantsComponent,
  TenantDetailsComponent,
  TenantWorkspacesTableComponent,
  CreateTenantComponent,
  EditTenantComponent,
  TenantConfigureSsoComponent,
  MigrateWorkspaceModalComponent,
  MigrateWorkspaceConfirmationModalComponent,
  TenantWorkspaceDetailsComponent,
  TenantWorkspaceDigitalPropertiesListComponent,
  MigrationTroubleshootModalComponent,
  TenantRemoveSsoModalComponent,
  TenantTabWorkspacesComponent,
  TenantTabAcademyComponent,
  TenantAcademyTableComponent,
  AssignAcademyRolesModalComponent,
  EditTenantWorkspaceComponent,
  CreateTenantConfirmationModalComponent,
  UsageLimitComponent,
  TenantWorkspaceDigitalPropertiesEditComponent,
  EditTenantWorkspaceDigitalPropertyFormComponent,
  AmpApiKeyModalComponent,
  AmpApiKeyComponent,
  AllOrganizationsComponent,
  OrganizationsTableComponent,
  CreateDigitalPropertyComponent,
  CreateBulkWsPlusDpComponent,
  CreateTenantWorkspaceSelectorComponent,
];

@NgModule({
  declarations: [...sharedComponents],
  imports: [
    CommonModule,
    SharedModule,
    PortfolioSharedModule,
    ScanningAgentSwitchComponent,
    CreateTenantWorkspacePlusDpComponent,
    DigitalAssetComplexityCalculatorComponent,
    PackageSelectorComponent,
    ScanDefaultTimeoutComponent,
    ConfidentialScanningSwitchComponent,
    ScanningAgentDebugModeSwitchComponent,
  ],
  exports: [...sharedComponents],
})
export class SharedTenantsModule {}
